import { useAppStateActions, useLanguage, useTranslation } from 'appState';
import { ButtonRect } from 'components';
import amImage from './certificate_am.png';
import enImage from './certificatev2_en.png';
import s from './AfterLandingPage.module.scss';
import classnames from 'classnames';
import { useEffect } from 'react';
import { Language } from 'types';

const AfterLandingPage: React.FC = () => {
  const { appFlowForward, logout } = useAppStateActions();
  const lang = useTranslation('AfterLandingPage');
  const language = useLanguage();
  const picture = (language: Language) => {
    switch (language) {
      case 'English':
      case 'Arabic':
        return enImage;
      case 'Amharic':
        return amImage;
      case 'Italian':
        return enImage;
    }
  };
  // const backgroundUrl = () => `url(${picture(language)})`;

  // Don't leave any possibility of users being left logged in by forcing logout here.
  // Should help to avoid any weird log-in flow bugs
  useEffect(() => {
    logout();
  }, [logout]);

  return (
    <div className={s.container}>
      <div
        className={classnames(s.afterLoginImgContainer, s[language])}
      >
        <img src={picture(language)} alt={"certificate example"} className={s.afterLoginImg}/>
      </div>
      <div className={s.content}>
        <p>{lang.welcomeSecond}</p>
      </div>
      <ButtonRect
        onClick={appFlowForward}
        text={lang.buttonText}
        className={s.startButton}
      />
    </div>
  );
};

export default AfterLandingPage;
